import type { FaireProductEntity } from "../../entity_types/product";

export const p_u43vjuxhfu: FaireProductEntity = {
  token: "p_u43vjuxhfu",
  type: "product",
  name: "Gourmet Warehouse Smoky Peach BBQ sauce",
  brandToken: "b_esfhqeqhi5",
  brandName: "Gourmet Warehouse Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/2a5bc10b644488d1015d69b359caf7e063c3c5b523e1ee51fec69530ff267fb5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36797445e2f2746509b9df01e276a9a0872eb7bfb7ded9ddde09d638afde4a1c.jpeg",
    "https://cdn.faire.com/fastly/378ff8b8cd68336749d8588e2e00098fd4b3e25f4fbab0f41c22dfb61baac5f8.jpeg",
    "https://cdn.faire.com/fastly/087e8a9ae4f3fedd4dcf7660961c0bd4350375c1f922f6267f18e26dd6fd700e.png",
    "https://cdn.faire.com/fastly/998977cf094f4796fc546ef4dadf642dedbfa98fe278bb05587cf1d5a6690fd5.jpeg",
    "https://cdn.faire.com/fastly/6b6715f97a5a8ae5a9d10497c30711af16a26cee515696c8d40227f29f0ee89a.png",
    "https://cdn.faire.com/fastly/8c45339ededcf748d4c0ca9b2e3c7648e108a4d8ae3a1016f8c1604aba8c3564.png",
    "https://cdn.faire.com/fastly/99ad8b0678be4808caa2776fb168e5c91bb6e1938e0d39a33ed6769b2dd5ca10.png",
  ],
  priceDollars: 4.59,
  description:
    'Smoky Peach BBQ Sauce – Sweet, Smoky & Seriously Satisfying\n\nGourmet Warehouse’s Smoky Peach BBQ Sauce blends the juicy sweetness of ripe peaches with rich brown sugar and a signature smoky spice mix to deliver a bold, mouthwatering flavor. Perfect for grilling, glazing, or dipping, it enhances everything from ribs and chicken to seafood, shrimp, and even vegetables.\n\nThis versatile sauce is a customer favorite, offering a unique twist on traditional BBQ that appeals to adventurous eaters and backyard grillers alike. Whether used as a finishing glaze or served on the side, it brings elevated flavor to any dish.\n\nBoost your basket size: Pair it with our Smoky Peach Seasoning & Rub for a complete flavor set your customers will love. Great for bundling, gift sets, or themed grilling displays. A proven best-seller with strong repeat purchase potential.\n\nHigh quality packaging. Label is printed on textured "estate" paper with matching bottle neck shrink wrap that reads "small batch, handcrafted". 16 oz glass bottle.\n\nInspired by their daily surroundings on Hilton Head Island, in the heart of South Carolina’s Lowcountry, Gourmet Warehouse enjoys a rich 30 year history of handcrafting extraordinary gourmet products in small batches, one scoop at a time.',
  tags: [],
  msrpDollars: 9.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:09.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
